const SKBookingList = ({ records }) => {
    const skeletonRows = Array.from({ length: records });
    return (
        skeletonRows.map((_, rowIndex) => (
            <div className="accordion-item" key={rowIndex}>
                <div className="accordion-header skeleton" id="flush-headingThree">
                    <div className="accordion-button ">
                        <div className="booksesson">
                            <div className="bookImg skeleton">
                                <img src={""} alt="boximg2" />
                            </div>
                            <div className="rightsesson skeleton">
                                <h6 className="">Curabitur dignissim dui</h6>
                                <h4 className="">At pretium nulla ex risus tortor purus ac sed ante torquent in nostra pretium odio molestie nulla</h4>
                                <div className="ourdetails ">
                                    <div className="schedulesec">
                                        <ul>
                                            {/* <li><i className="bi bi-calendar2-event-fill"></i><span>Tue, Aug 10 - 11:00 pm</span></li> */}
                                            <li><i className="bi bi-people-fill"></i><span>3 People  - 120.00$</span></li>
                                            <li><i className="fa-solid fa-cart-shopping"></i><span>Mon, 3 Aug</span></li>
                                        </ul>
                                    </div>
                                    <div className="hideShowClick">
                                        <button className="collapsed showhide" type="button" data-bs-toggle="collapse" data-bs-target="#flush-collapseThree" aria-expanded="false" aria-controls="flush-collapseThree">Show details <i className="fa-solid fa-circle-chevron-down iconChev"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div id="flush-collapseThree" className="accordion-collapse collapse" aria-labelledby="flush-headingThree" data-bs-parent="#accordionFlushExample">
                    <div className="accordion-body">
                        <div className="travelstatus">
                            <div className="statusbox">
                                <div className="firstlable">
                                    <h5>Status</h5>
                                </div>
                                <div className="showstatus">
                                    <span className="greenstatus">Travel status</span>
                                </div>
                            </div>
                            <div className="statusbox">
                                <div className="firstlable">
                                    <h5>Lead traveler</h5>
                                </div>
                                <div className="showstatus">
                                    <h6>Maguy Fortin (France) +998 90 900 09 90 kj12kgkjh14141h@toursxplorer.com</h6>
                                </div>
                            </div>
                            <div className="statusbox">
                                <div className="firstlable">
                                    <h5>Language</h5>
                                </div>
                                <div className="showstatus">
                                    <h6>Live guide: French</h6>
                                </div>
                            </div>
                            <div className="statusbox">
                                <div className="firstlable">
                                    <h5>Tickets</h5>
                                </div>
                                <div className="showstatus">
                                    <h6>3x Adult</h6>
                                    <a href="javascript:void(0)">toursxplorer.com/tickets</a>
                                    <a href="javascript:void(0)">toursxplorer.com/tickets</a>
                                    <a href="javascript:void(0)">toursxplorer.com/tickets</a>
                                </div>
                            </div>
                            <div className="statusbox">
                                <div className="firstlable">
                                    <h5>Booked on</h5>
                                </div>
                                <div className="showstatus">
                                    <h6>Mon Aug 5</h6>
                                </div>
                            </div>
                            <div className="ourbtnsec">
                                <button className="btn cancelbtn"><i className="bi bi-x-circle-fill"></i> Сancelation</button>
                                <button className="btn resendbtn">Resend <i className="bi bi-arrow-right-circle-fill"></i></button>
                                <button className="btn downloadbtn"><i className="fa-solid fa-file-arrow-down"></i> Download</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ))
    )
}
export default SKBookingList